import { render, staticRenderFns } from "./SocialAuthInfoPopover.vue?vue&type=template&id=3ab7fba8&"
import script from "./SocialAuthInfoPopover.vue?vue&type=script&lang=js&"
export * from "./SocialAuthInfoPopover.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuthInfoPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports